import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "~/Containers/ContainerCreate";
import { getTopGenres } from "~/api/getStats";

class TopGenresContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const genres = (data && data.data) || {};
    return render({ genres, loading, failure });
  };
}

export default CreateContainer(getTopGenres, TopGenresContainer);
